"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EZSPMLink = exports.SchemeUtils = void 0;
var ezbuy_1 = require("app-scheme-utils/lib/ezbuy");
var ezbuyapp_1 = require("utils/browser/ezbuyapp");
var tyrande_1 = require("tyrande");
var WebSiteStore_1 = require("mobile/models/WebSiteStore");
exports.SchemeUtils = new ezbuy_1.Parser(ezbuyapp_1.default.isInEzbuyApp);
exports.EZSPMLink = function (link, EZSpmLink) {
    var symbol = link.indexOf("?") >= 0 ? "&" : "?";
    var initialLink = "" + link.trim() + symbol + "ezspm=" + EZSpmLink.trim();
    var convertedLink = decodeURIComponent(exports.SchemeUtils.convertToAutoLink(initialLink));
    tyrande_1.sendEzspmByLink(convertedLink, false);
    clickJump(convertedLink);
};
var clickJump = function (link) {
    link = WebSiteStore_1.getStore().replaceUrl(link);
    open(link);
};
